<template>
  <div class="recaptchaContainer">
    <div id="recaptcha-container" />
    <div
      v-if="!loaded"
      class="recaptchaSpinner recaptchaContainer"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      />
    </div>
  </div>
</template>

<script>
import { auth } from '@/firebase'
import { RecaptchaVerifier } from 'firebase/auth'

export default {
  name: 'AuthRecaptcha',
  emits: ['solved', 'expired'],
  data: function () {
    return {
      loaded: false
    }
  },
  async mounted() {
    var recaptchaVerifier = new RecaptchaVerifier(
      'recaptcha-container',
      {
        size: 'normal',
        callback: () => this.$emit('solved', recaptchaVerifier),
        'expired-callback': () => this.$emit('expired', recaptchaVerifier)
      },
      auth
    )
    await recaptchaVerifier.render()
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
// Size of created recaptcha
.recaptchaContainer {
  height: 78px;
  width: 304px;
}
.recaptchaSpinner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
